/* eslint eol-last: ["error", "never"] */
/* eslint space-before-function-paren: ["error", "never"] */
// import axios from 'axios';
// import lang from '../../locales/en';
import Vue from 'vue'
import axios from 'axios'

export default {
    addOfertas({ commit, dispatch }, oferta) {
        return new Promise((resolve, reject) => {
            commit('setLoader')
            axios.post('/ofertas', oferta)
                .then(response => {
                    commit('setRegister', false)
                    commit('setOferta', response.data.data)
                    commit('setLoader')
                    resolve(response)
                })
                .catch(err => {
                    commit('setLoader')
                    if (err.response.data.code === 401) {
                        Vue.notify({
                            group: 'loggedIn',
                            text: 'Su sesión ha caducado',
                            type: 'red accent-2',
                            duration: 5000,
                        })
                        dispatch('logout', null, { root: true })
                    } else {
                        reject(err)
                    }
                })
        })
    },

    updateOfertas({ commit, dispatch }, oferta) {
        return new Promise((resolve, reject) => {
            commit('setLoader')
            const id = oferta.id
            axios.put(`/ofertas/${id}`, oferta)
                .then(response => {
                    commit('setRegister', false)
                        // commit('setUpdateCategorias', categoria)
                    dispatch('getOfertas')
                    commit('setLoader')
                    resolve(response)
                })
                .catch(err => {
                    commit('setLoader')
                    if (err.response) {
                        if (err.response.data.code === 401) {
                            Vue.notify({
                                group: 'loggedIn',
                                text: 'Su sesión ha caducado',
                                type: 'red accent-2',
                                duration: 5000,
                            })
                            dispatch('logout', null, { root: true })
                        }
                    } else {
                        reject(err)
                    }
                })
        })
    },

    getOfertas({ commit, dispatch }) {
        return new Promise((resolve, reject) => {
            commit('setLoader')
            axios.get('/ofertas')
                .then(response => {
                    commit('setOfertas', response.data)
                    commit('setLoader')
                    resolve(response)
                })
                .catch(err => {
                    commit('setLoader')
                    if (err.response.data.code === 401) {
                        Vue.notify({
                            group: 'loggedIn',
                            text: 'Su sesión ha caducado',
                            type: 'red accent-2',
                            duration: 5000,
                        })
                        dispatch('logout', null, { root: true })
                    } else {
                        reject(err)
                    }
                })
        })
    },

    deleteOfertas({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            commit('setLoader')
            axios.delete(`/ofertas/${id}`)
                .then(response => {
                    dispatch('getOfertas')
                    commit('setLoader')
                    resolve(response)
                })
                .catch(err => {
                    commit('setLoader')
                    if (err.response.data.code === 401) {
                        Vue.notify({
                            group: 'loggedIn',
                            text: 'Su sesión ha caducado',
                            type: 'red accent-2',
                            duration: 5000,
                        })
                        dispatch('logout', null, { root: true })
                    } else {
                        reject(err)
                    }
                })
        })
    },

    async reportOfertas({ commit, dispatch }, params) {
        commit('setLoader')
        return await axios.post('/ofertas/download/pdf', params, {
                responseType: 'blob',
            })
            .then(response => {
                commit('setLoader')
                return response
            })
            .catch(err => {
                if (err.response.data.code === 401) {
                    commit('setLoader')
                    Vue.notify({
                        group: 'loggedIn',
                        text: 'Su sesión ha caducado',
                        type: 'red accent-2',
                        duration: 5000,
                    })
                    dispatch('logout', null, { root: true })
                } else {
                    commit('setLoader')
                    Vue.notify({
                        group: 'loggedIn',
                        text: 'Hubo un problema al descargar',
                        type: 'red accent-2',
                        duration: 5000,
                    })
                }
            })
    },

    fetchUsuarias() {
      return new Promise((resolve, reject) => {
        axios.get('/usuarias')
          .then(response => {
            // Guarda directamente en data local del componente
            this.usuarias = Array.isArray(response.data) ? response.data : []
            resolve(response.data)
          })
          .catch(err => {
            if (err.response?.data?.code === 401) {
              Vue.notify({
                group: 'loggedIn',
                text: 'Su sesión ha caducado',
                type: 'red accent-2',
                duration: 5000,
              })
              this.$store.dispatch('logout', null, { root: true })
            } else {
              Vue.notify({
                group: 'loggedIn',
                text: 'No se pudieron cargar las candidatas',
                type: 'red accent-2',
                duration: 5000,
              })
              reject(err)
            }
          })
      })
    },

    async printer({ commit, dispatch }, id) {
        commit('LOADER', true, { root: true })
        return await axios({
                method: 'get',
                url: `/oferta/download/pdf/${id}`,
                responseType: 'blob',
            })
            .then(response => {
                commit('LOADER', false, { root: true })
                return response
            })
            .catch(err => {
                commit('LOADER', false, { root: true })
                if (err.response.data.code === 401) {
                    Vue.notify({
                        group: 'loggedIn',
                        text: 'Su sesión ha caducado',
                        type: 'red accent-2',
                        duration: 5000,
                    })
                    dispatch('logout', null, { root: true })
                } else {
                    Vue.notify({
                        group: 'loggedIn',
                        text: 'Hubo un problema al descargar',
                        type: 'red accent-2',
                        duration: 5000,
                    })
                }
            })
    },
}